<div class="tw-max-w-4xl">
  <ng-content></ng-content>
</div>
